import styled from "styled-components";
import { CmsPageDefaultBox } from "./cms-page.default.box";

export const CmsPageSiCisBox = styled(CmsPageDefaultBox)`
    background-color: #ffffff;
`;